import Vue from 'vue';
import api from '@/request/api'; // 导入api接口
import Fragment from 'vue-fragment';
import VueCookies from 'vue-cookies';
// import Vconsole from 'vconsole'
// let vConsole = new Vconsole()

// 自定义基础组件
import 'vant/lib/index.css';
import './assets/fonts/iconfont.css';
import './assets/fonts/iconfont';
import {
  Button,
  PullRefresh,
  AddressEdit,
  Field,
  Step,
  Steps,
  Picker,
  Cell,
  CellGroup,
  Popup,
  Area,
  Loading,
  Icon,
  Toast,
  CountDown,
  Notify,
  Checkbox,
  Overlay,
  DatetimePicker,
  List,
  Swipe,
  SwipeItem,
  Dialog,
  ActionSheet,
  Slider,
  Tab,
  Tabs,
  Radio,
  RadioGroup,
  Uploader,
} from 'vant';

import Input from '@/components/Input.vue';
import vForm from '@/components/v-form/index';
import Form from '@/components/Form.vue';
import SelfButton from '@/components/Button.vue';
import SelfLoading from '@/components/Loading/index';
import MessageCode from '@/components/MessageCode.vue';
import SelfSelect from './components/SelfSelect/indxex.vue';

import SelfPopup from './components/dialogPopup/index';
import store from './store';
import router from './router';
import App from './App.vue';


Vue.prototype.$api = api;
router.beforeEach((to, from, next) => {
  window.document.title = to.meta.title;
  if (to.path) {
    // eslint-disable-next-line no-underscore-dangle
    if (window._hmt) {
      // eslint-disable-next-line no-underscore-dangle
      window._hmt.push(['_trackPageview', `/#${to.fullPath}`]);
    }
  }
  if (to.meta.content) {
    const mate = document.querySelector('meta[name=viewport]');
    mate.setAttribute('content', 'width=device-width,initial-scale=0.5,minimum-scale=0.5,maximum-scale=1,user-scalable=yes');
  } else {
    const mate = document.querySelector('meta[name=viewport]');
    mate.setAttribute('content', 'width=device-width,initial-scale=1,user-scalable=no');
  }
  next();
});


Vue.component('Input', Input);
Vue.component('Form', Form);
Vue.component('MessageCode', MessageCode);
Vue.component('SelfButton', SelfButton);
Vue.component('SelfSelect', SelfSelect);

Vue.use(Button)
  .use(PullRefresh)
  .use(AddressEdit)
  .use(Field)
  .use(Step)
  .use(Steps)
  .use(Picker)
  .use(Cell)
  .use(CellGroup)
  .use(Popup)
  .use(Area)
  .use(Loading)
  .use(Icon)
  .use(Toast)
  .use(Notify)
  .use(CountDown)
  .use(Checkbox)
  .use(DatetimePicker)
  .use(List)
  .use(Overlay)
  .use(Swipe)
  .use(SelfPopup)
  .use(Dialog)
  .use(ActionSheet)
  .use(Slider)
  .use(SwipeItem)
  .use(Tab)
  .use(Tabs)
  .use(SelfLoading)
  .use(Fragment.Plugin)
  .use(Radio)
  .use(RadioGroup)
  .use(vForm)
  .use(Uploader);

Vue.config.productionTip = false;
window.globalRouter = router;
Vue.use(VueCookies);
// try {
//   if (window.location.origin === 'https://fintech.baiwang.com') {
//     import('bw-front-logger').then((module) => {
//       const CollectErrors = module.default;
//       const co = new CollectErrors({
//         appId: 'intell-loan', // 必填和发版平台模块名称保持一致
//       });
//     });
//   }
// } catch (error) {
//   console.log(error);
// }
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
Vue.config.ignoredElements = ['wx-open-launch-weapp'];
